import { useEffect, useRef, useState } from 'react'
import { Wrapper, Status } from '@googlemaps/react-wrapper'

import Loader from 'src/components/Loader'

export function MyMapComponent({ center, zoom = 10, pharmacies, togglePharmacyOpen }) {
  const ref = useRef()

  useEffect(() => {
    const firstPharmacy = pharmacies?.[0] || {}

    const map = new window.google.maps.Map(ref.current, {
      center: {
        lat: (center?.lat || firstPharmacy?.Lat) * 1,
        lng: (center?.long || firstPharmacy.Long) * 1,
      },
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      zoom,
    })

    if (pharmacies?.length) {
      pharmacies.forEach((pharmacy, index) => {
        const marker = new window.google.maps.Marker({
          position: {
            lat: pharmacy.Lat * 1,
            lng: pharmacy.Long * 1,
          },
          label: {
            text: `${index + 1}`,
            color: '#ffffff',
          },
        })

        marker.addListener('click', () => {
          togglePharmacyOpen(pharmacy.NPI)
          map.setCenter(marker.getPosition())
        })

        marker.setMap(map)
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pharmacies, center, zoom])

  return <div ref={ref} id="map" />
}

export const PharmacyListMap = (props) => {
  const renderer = (status) => {
    switch (status) {
      case Status.LOADING:
        return <Loader color="#ccc" />
      case Status.FAILURE:
        return <p>Failed</p>
      case Status.SUCCESS:
        return <MyMapComponent {...props} />
    }
  }

  return <Wrapper apiKey={'AIzaSyCl3VQFF6c9Jd34ebvt4FtOflASMvkv_uQ'} render={renderer} />
}

export default PharmacyListMap
